import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import {
  FooterSection,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Chat,
  FooterContainer,
  Language,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  const SocialLink = ({ href, src }: SocialLinkProps) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={src}
      style={{ marginLeft: "0.25rem", marginRight: "0.25rem" }}
    >
      <SvgIcon src={src} width="25px" height="25px" />
    </a>
  );

  return (
    <>
      <FooterSection>
        <Container>
          <Row gutter={[32, 32]} justify="space-between">
            <Col lg={12} md={12} sm={24} xs={24}>
              <Language>{t("Contact")}</Language>
              <Para>{t("Do you have any question? Feel free to reach out.")}</Para>
              <a href="mailto:info@voviva.net">
                <Chat>{t("Email Us")}</Chat>
              </a>
            </Col>
            <Col lg={12} md={12} sm={24} xs={24}>
              <Language>{t("Address")}</Language>
              <Para>Huttenstrasse 43</Para>
              <Para>8006 Zurich</Para>
            </Col>
          </Row>
        </Container>
        <Container>
          <Row justify="space-between" align="middle">
            <Col>
              <NavLink to="/privacy-policy">
                {t("Privacy Policy")}
              </NavLink>
            </Col>
            {/* other footer links */}
          </Row>
        </Container>
      </FooterSection>

      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem", paddingBottom: "2rem" }}
          >
            <Col>
              <NavLink to="/">
                <LogoContainer>
                  <SvgIcon
                    src="logo.svg"
                    aria-label="homepage"
                    width="120px"
                    height="auto"
                  />
                </LogoContainer>
              </NavLink>
            </Col>
            {/* Fixed-width container to prevent shrinking */}
            <Col style={{ flex: "none", width: "100px", minWidth: "100px" }}>
              <FooterContainer
                style={{
                  display: "flex",
                  flexWrap: "nowrap",
                  overflow: "visible",
                  flex: "none",
                  width: "100px",
                  justifyContent: "center",
                }}
              >
                <SocialLink
                  href="https://www.linkedin.com/company/safestroll"
                  src="linkedin.svg"
                />
                <SocialLink
                  href="https://www.instagram.com/safestroll_app/"
                  src="instagram.svg"
                />
              </FooterContainer>
            </Col>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
